import React from 'react';

import { Incrementer } from '@travel/ui';

import styles from './amountInput.module.scss';

type Props = {
  /** Number of current value */
  counter: number;
  /** Flag to define whether the left side will be disabled or not */
  isLeftDisabled: boolean;
  /** Flag to define whether the right side will be disabled or not */
  isRightDisabled: boolean;
  /** Callback to be called when the value is decreased */
  onDecrease: (event: React.MouseEvent) => void;
  /** Callback to be called when the value is increased */
  onIncrease: (event: React.MouseEvent) => void;
  /** who is that kiddo? */
  counterType: string;
  /** Custom Decrement Icon */
  decrementIcon?: JSX.Element;
  /** Custom Increment Icon */
  incrementIcon?: JSX.Element;
  /** Make counter text bold */
  isCounterBolded?: boolean;
  /** Text after counter */
  counterText?: string;
};

function CounterForm(props: Props) {
  const {
    counterType,
    counter,
    isLeftDisabled,
    isRightDisabled,
    onDecrease,
    onIncrease,
    decrementIcon,
    incrementIcon,
    isCounterBolded,
    counterText,
  } = props;
  return (
    <div className={styles.amountFormWrapper}>
      <div className={styles.amountForm}>
        <Incrementer
          value={counter}
          isLeftDisabled={isLeftDisabled}
          isRightDisabled={isRightDisabled}
          onDecrease={onDecrease}
          onIncrease={onIncrease}
          decrementAriaLabel={`decrement ${counterType} number`}
          incrementAriaLabel={`increment ${counterType} number`}
          data-testid={`amountInput-incrementer-${counterType}`}
          decrementIcon={decrementIcon}
          incrementIcon={incrementIcon}
          isCounterBolded={isCounterBolded}
          className={styles.incrementer}
          counterClassName={styles.counterValue}
          afterCounter={counterText && <span className={styles.counterText}>{counterText}</span>}
          buttonClassName={styles.incrementerButton}
          disabledButtonClassName={styles.incrementerDisabledButton}
        />
      </div>
    </div>
  );
}

export default React.memo(CounterForm);
